import InfoPersoStep2FormComponent from '../../components/info-perso/InfoPersoStep2FormComponent';


export default function InfoPersoStep2Bloc() {

      return (
        <div className="">
          <div className="">
            {/* <h2 className="card-title bleu">Votre adresse :</h2>
            <p className="text m-y-sm">Cette information nous a été transmises par votre service des ressources humaines. En cas d'erreur, vous pouvez la corriger. </p> */}
            <InfoPersoStep2FormComponent/>  
          </div>
          
        </div>
      )
}